import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../components/DataTable';
import { Plus, Filter, AlertTriangle, Bell, Users, Calendar, Trash2, ChevronDown } from 'lucide-react';
import SyncStatus from '../components/SyncStatus';
const Alerts: React.FC = () => {
  const navigate = useNavigate();
  const columns = [{
    key: 'name',
    label: 'Alert Name',
    sortable: true
  }, {
    key: 'description',
    label: 'Description',
    sortable: true
  }, {
    key: 'matches',
    label: 'Matches',
    sortable: true
  }, {
    key: 'lastRun',
    label: 'Last Run',
    sortable: true
  }, {
    key: 'status',
    label: 'HubSpot Sync',
    sortable: true,
    render: (value: string) => <SyncStatus status={value as 'Synced' | 'Not Synced'} data-id="element-851" />
  }];
  const alertsData = [{
    id: 1,
    name: 'Potential Analytics Upsell (High Manual Reporting)',
    description: 'Flags accounts doing heavy manual analysis, suggesting they\'re ready for the "Advanced Analytics" package.',
    category: 'Upsell & Expansion',
    matches: 5,
    lastRun: '2 hours ago',
    status: 'Synced'
  }, {
    id: 2,
    name: 'Potential Brand Portal Upsell (Brand Filter Usage)',
    description: 'Identifies accounts providing reports to external partners, signaling a need for "Brand Portals".',
    category: 'Upsell & Expansion',
    matches: 8,
    lastRun: '1 day ago',
    status: 'Synced'
  }, {
    id: 3,
    name: 'User Overage - License Limit Exceeded',
    description: 'A direct expansion signal that an account has added more users than their subscription allows and needs to be billed for the overage.',
    category: 'Upsell & Expansion',
    matches: 3,
    lastRun: '12 hours ago',
    status: 'Synced'
  }, {
    id: 4,
    name: 'Manufacturer Not Using Assemblies',
    description: 'A critical alert for a key persona not using a sticky feature, indicating a major onboarding failure or churn risk.',
    category: 'Churn & Onboarding Risk',
    matches: 7,
    lastRun: '6 hours ago',
    status: 'Synced'
  }, {
    id: 5,
    name: 'High-Value Account is Underusing the Platform',
    description: 'Flags high-MRR customers who are dangerously disengaged from the product, requiring immediate proactive outreach to prevent churn.',
    category: 'Churn & Onboarding Risk',
    matches: 2,
    lastRun: '1 day ago',
    status: 'Not Synced'
  }, {
    id: 6,
    name: 'Distributor with Unusually Low Sales Volume',
    description: 'Identifies a distributor whose sales volume is below the expected baseline for their persona, suggesting a potential business or adoption problem.',
    category: 'Churn & Onboarding Risk',
    matches: 4,
    lastRun: '8 hours ago',
    status: 'Not Synced'
  }, {
    id: 7,
    name: 'Small Customer Using E-commerce Menu Exclusively',
    description: 'A strategic alert for the product team that identifies customers who are essentially buying the entire platform for one feature, signaling a potential to modularize that feature into a new product.',
    category: 'Product & Strategy',
    matches: 6,
    lastRun: '3 hours ago',
    status: 'Synced'
  }];
  const handleAlertClick = (alert: any) => {
    navigate(`/alerts/${alert.id}`);
  };
  return <div className="space-y-6" data-id="element-852">
      <div className="flex justify-between items-center" data-id="element-853">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-854">Alerts</h1>
        <button className="bg-[#0070d2] hover:bg-[#0057a3] text-white px-4 py-2 rounded-md flex items-center gap-2" data-id="element-855">
          <Plus size={18} data-id="element-856" />
          <span data-id="element-857">New Alert</span>
        </button>
      </div>
      <div className="grid grid-cols-3 gap-4" data-id="element-858">
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-859">
          <div className="flex items-center gap-3" data-id="element-860">
            <div className="p-2 rounded-full bg-red-100 text-red-600" data-id="element-861">
              <AlertTriangle size={20} data-id="element-862" />
            </div>
            <div data-id="element-863">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-864">
                Total Alerts
              </h3>
              <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-865">7</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-866">
          <div className="flex items-center gap-3" data-id="element-867">
            <div className="p-2 rounded-full bg-blue-100 text-blue-600" data-id="element-868">
              <Users size={20} data-id="element-869" />
            </div>
            <div data-id="element-870">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-871">
                Matching Accounts
              </h3>
              <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-872">35</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-md border border-gray-200 shadow-sm" data-id="element-873">
          <div className="flex items-center gap-3" data-id="element-874">
            <div className="p-2 rounded-full bg-green-100 text-green-600" data-id="element-875">
              <Calendar size={20} data-id="element-876" />
            </div>
            <div data-id="element-877">
              <h3 className="text-sm font-medium text-gray-500" data-id="element-878">
                Last Updated
              </h3>
              <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-879">2h ago</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden" data-id="element-880">
        <DataTable columns={columns} data={alertsData} onRowClick={handleAlertClick} data-id="element-881" />
      </div>
    </div>;
};
export default Alerts;